import icon from 'vue-svgicon';

icon.register({
  chair: {
    width: 40,
    height: 40,
    viewBox: '0 0 40 40',
    // eslint-disable-next-line max-len
    data: '<path class="zu-seat" d="m9.41 2.44c-3.69 1.03-3.11 3.48-4.66 6.4-0.59 1.12-1.48 2.01-1.87 3.24-0.5 1.59-0.47 3.75-0.54 5.4-0.14 3.12-0.36 7.44 0.6 10.44 0.4 1.27 1.2 2.08 1.81 3.24 1.13 2.14 1.36 5.39 3.96 6.25 0.83 0.27 1.95 0.23 2.82 0.23h10.23c1.33 0 3.45 0.17 3.94-1.48 0.39-1.28-0.67-2.42-1.82-2.78h-8.82c-2.72-0.07-3.48-0.39-4.02-3.3-0.44-1.63 0.32-2.1 0-4.68-0.14-2.33-0.66-3.55-0.56-6.12l0.68-5.4-0.32-3.24c0.05-1.1 0.78-3.27 1.83-3.74 0.57-0.26 1.74-0.22 2.39-0.22h7.06c1.46-0.01 3.09-0.06 3.58-1.8 0.74-2.62-3.14-2.52-4.64-2.44h-11.65zm18.71 2.8c-1.25 3.72-3.52 3.24-6.71 3.24h-8.03v5.4s-0.42 6.48-0.42 6.48 0.57 6.48 0.57 6.48l-0.24 4.68h9.53c2.74 0 4.31 0.31 5.3 3.24 1.29 0 6 0.23 6.86-0.36 1.04-0.72 1.53-3.11 1.74-4.32 0.69-3.87 0.93-7.6 0.93-11.52-0.01-2.1-0.67-7.69-1.15-9.72-0.22-0.99-0.66-2.65-1.52-3.24-0.64-0.45-1.86-0.36-2.63-0.36h-4.23z"></path>',
  },
});



// WEBPACK FOOTER //
// ./src/components/svg/_components/chair.js